module.exports = __webpack_public_path__ + "static/img/lz.b285c2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/myteam/lz.png
// module id = Yw8j
// module chunks = 1